<template>
  <div class="product-center">
    <page-banner title="产品中心" content="拥有多种智能产品"></page-banner>
    <div class="breadcrumb-nav">
      <v-breadcrumb separator="/" separatorClass="fa fa-angle-right">
        <v-breadcrumb-item to="/">首页</v-breadcrumb-item>
        <v-breadcrumb-item to="/product">产品中心</v-breadcrumb-item>
      </v-breadcrumb>
    </div>
    <div class="product-conter">
      <div class="product-conter">
        <div class="system-fl">
          <div class="system-nav">
            <div class="fl-header">
              <strong>产品中心</strong>
            </div>
            <div class="fl-content">
              <ul>
                <li
                  v-for="item in types"
                  :key="item.id"
                  :data-id="item.id"
                  v-on:click="showProducts(item.id)"
                >
                  <a href="###">{{item.name}}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="system-fr" ref="content">
          <ul>
            <li v-for="product in category" :key="product.id" v-on:click="deta_info(product.id)">
              <div style="text-align:center;">
                <img class="thumbnail" :src="product.images[0].path" width="100%" height="100%">
              </div>
              <p style="padding:0 20px;text-align:center;">{{product.product_name}}</p>
            </li>
          </ul>
          <!-- <v-pagination :total="total" v-on:prev="prev" v-on:next="next" v-on:changePage="changePage"></v-pagination>  width="170"
          height="145"-->
          <div class="pagination">
            <v-pagination :total="total" :display="12" v-if="total>0"></v-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.product-center {
  background-color: #f5f5f5;
}
.product-conter {
  /* width: 1200px; */
  width: 1000px;
  min-height: 800px;
  margin: 10px auto;
  overflow: hidden;
  /* background-color: #f5f5f5; */
}
.thumbnail {
  padding: 5px 5px;
}
.system-fl {
  width: 235px;
  float: left;
  background-color: #fff;
}
.system-nav {
  width: 250px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.fl-header {
  width: 250px;
  height: 80px;
  font-size: 20px;
  line-height: 80px;
  text-align: center;
  border-bottom: 1px solid #ebebeb;
}
.fl-content {
  background-color: #fff;
  margin: 15px 0;
  overflow: hidden;
}
.fl-content ul {
  width: 250px;
  overflow: hidden;
}
.fl-content ul li {
  width: 240px;
  height: 42px;
  padding-left: 4px;
  box-sizing: border-box;
  line-height: 42px;
  font-size: 14px;
  float: left;

  /* border-bottom: 1px solid #ccc; */
  margin: 0 5px;
}

.fl-content ul li:hover {
  background-color: #f2f2f2;
}

.system-fr {
  /* width: 930px; */
  width: 750px;
  display: inline-block;
  padding-left: 15px;
}
.system-fr ul {
  /* width: 930px; */
  width: 750px;
}
.system-fr ul li {
  width: 200px;
  height: 260px;
  background-color: #fff;
  /* border: 1px solid #ccc; */
  margin: 0px 15px 30px 15px;
  float: left;
  cursor: pointer;
  transition: 0.3s;
}
.system-fr ul li:hover {
  box-shadow: 0px 15px 30px rgb(0, 0, 0, 0.1);
  transform: translate3d(0, -2px, 0);
}

.pagination {
  /* width: 930px; */
  width: 750px;
  height: 80px;
  overflow: hidden;
  text-align: center;
}
</style>
<script>
import showProductVue from "./showProduct.vue";
export default {
  name: "productCenter",
  data() {
    return {
      types: [],
      total: 0,
      category: [
        {
          id: 25,
          name: "动态人脸识别",
          products: [
            {
              id: 23,
              imgs: [
                {
                  id: 7,
                  path: "upload/1250.jpg",
                  products_id: 25
                }
              ],
              pro_int: "校园进出门口安装人脸识别技术",
              product_name: "校园人脸识别"
            }
          ]
        },
        {
          id: 25,
          name: "动态人脸识别",
          products: [
            {
              id: 23,
              imgs: [
                {
                  id: 7,
                  path: "upload/1250.jpg",
                  products_id: 25
                }
              ],
              pro_int: "校园进出门口安装人脸识别技术",
              product_name: "校园人脸识别"
            }
          ]
        },
        {
          id: 25,
          name: "动态人脸识别",
          products: [
            {
              id: 23,
              imgs: [
                {
                  id: 7,
                  path: "upload/20158.jpg",
                  products_id: 25
                }
              ],
              pro_int: "校园进出门口安装人脸识别技术",
              product_name: "校园人脸识别"
            }
          ]
        },
        {
          id: 25,
          name: "动态人脸识别",
          products: [
            {
              id: 23,
              imgs: [
                {
                  id: 7,
                  path: "upload/20158.jpg",
                  products_id: 25
                }
              ],
              pro_int: "校园进出门口安装人脸识别技术",
              product_name: "校园人脸识别"
            }
          ]
        },
        {
          id: 25,
          name: "动态人脸识别",
          products: [
            {
              id: 23,
              imgs: [
                {
                  id: 7,
                  path: "upload/20158.jpg",
                  products_id: 25
                }
              ],
              pro_int: "校园进出门口安装人脸识别技术",
              product_name: "校园人脸识别"
            }
          ]
        },
        {
          id: 25,
          name: "动态人脸识别",
          products: [
            {
              id: 23,
              imgs: [
                {
                  id: 7,
                  path: "upload/20158.jpg",
                  products_id: 25
                }
              ],
              pro_int: "校园进出门口安装人脸识别技术",
              product_name: "校园人脸识别"
            }
          ]
        },
        {
          id: 25,
          name: "动态人脸识别",
          products: [
            {
              id: 23,
              imgs: [
                {
                  id: 7,
                  path: "upload/20158.jpg",
                  products_id: 25
                }
              ],
              pro_int: "校园进出门口安装人脸识别技术",
              product_name: "校园人脸识别"
            }
          ]
        }
      ]
    };
  },
  methods: {
    /** 显示产品信息 */
    showProducts(id) {
      var _this = this;
      this.$ajax(`/products.php?id=${id}&page=1`, "get", null, function(data) {
        var da = JSON.parse(data);
        _this.category = da.products;
        _this.total = _this.category.length;
      });
    },
    deta_info(id) {
      this.$router.push("/product/" + id);
    }
  },
  mounted() {
    var _this = this;
    $.ajax({
      url: "/product_type.php",
      type: "get",
      data: null,
      success: function(data, textStatus, jqXHR) {
        _this.types = JSON.parse(data);
        if (_this.types.length > 0) {
          _this.showProducts(_this.types[0].id);
        }
        // _this.$refs.content.innerHTML = _this.plans[0].content;
        // console.log(_this.plans);
        // alert("返回的数据" + data);
      }
    });
  }
};
</script>




// WEBPACK FOOTER //
// src/components/product_content.vue